// Tailwind class-name merger — shadcn's cn() helper combining clsx + tailwind-merge.ts.
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
